import Overview from "../views/Overview/Overview";
// import Users from "../views/Users/Users";
import Users from "../views/Users/Users.js";
import Savings from "../views/Savings/Savings";
import Saving from "../views/Savings/Saving";
import Options from "../views/Options/Options";
import UserSavings from "../views/Options/Savings";
import Investments from "../views/Investments/Investments";
import UserInvestments from "../views/Options/Investments";
import UserTransactions from "../views/Options/Transactions";
import Loans from "../views/Loans/Loans";
import Loan from "../views/Loans/Loan";
import Transactions from "../views/Transactions/Transactions";
import Transaction from "../views/Transactions/Transaction";

const dashboardRoutes = [
  {
    path: "/dashboard/users",
    name: "Users",
    exact: true,
    component: Users,
    protectedRoute: true,
  },
  {
    path: "/dashboard/savings",
    name: "Savings",
    exact: true,
    component: Savings,
    protectedRoute: true,
  },
  {
    path: "/dashboard/transactions",
    name: "Transactions",
    exact: true,
    component: Transactions,
    protectedRoute: true,
  },
  {
    path: "/dashboard/transactions/:transactionId",
    name: "Transactions",
    exact: true,
    component: Transaction,
    protectedRoute: true,
  },
  // {
  //   path: "/dashboard/investments",
  //   name: "Savings",
  //   exact: true,
  //   component: Investments,
  //   protectedRoute: true,
  // },
  {
    path: "/dashboard/users/:userId",
    name: "Modules",
    exact: true,
    component: Options,
    protectedRoute: true,
  },
  {
    path: "/dashboard/users/:userId/savings",
    name: "Modules",
    exact: true,
    component: UserSavings,
    protectedRoute: true,
  },
  {
    path: "/dashboard/savings/:savingsId",
    name: "Saving",
    exact: true,
    component: Saving,
    protectedRoute: true,
  },
  {
    path: "/dashboard/users/:userId/investments",
    name: "Modules",
    exact: true,
    component: UserInvestments,
    protectedRoute: true,
  },
  {
    path: "/dashboard/loans",
    name: "Modules",
    exact: true,
    component: Loans,
    protectedRoute: true,
  },
  {
    path: "/dashboard/loans/:loanId",
    name: "Modules",
    exact: true,
    component: Loan,
    protectedRoute: true,
  },
  {
    path: "/dashboard",
    name: "Overview",
    exact: true,
    component: Overview,
    protectedRoute: true,
  },
  {
    path: "/dashboard/users/:userId/transactions",
    name: "Overview",
    exact: true,
    component: UserTransactions,
    protectedRoute: true,
  },

  // { redirect: true, path: "/", to: "/dashboard", name: "Dashboard" }
];

export default dashboardRoutes;
